import * as Yup from "yup";

export const fileUploadValidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  author: Yup.string(),
  file: Yup.array().of(Yup.mixed()).min(1, "File is required"),
});
